/**
 * 商户结算统计
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户结算统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商户名称 :">
        <el-input
          size="small"
          v-model="formInline.merchantName"
          placeholder="请输入商户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="服务商 :">
        <el-input
          size="small"
          v-model="formInline.disCompanyName"
          placeholder="请输入服务商"
        ></el-input>
      </el-form-item>
      <el-form-item label="交易时间 : ">
        <el-date-picker
          size="small"
          v-model="formInline.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset()">清空</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="small" type="primary" @click="exportData"
        >导出数据</el-button
      >
      <el-button
        size="small"
        type="primary"
        @click="onOpenBatchExport"
        v-if="shouldShowButton()"
        >批量导出完税模板</el-button
      >
      <el-button size="small" @click="onOpenExportLog">导出记录</el-button>
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        fixed
        prop="merchantName"
        label="商户"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.merchantName)">
            {{ scope.row.merchantName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="disCompanyName"
        label="服务商"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.disCompanyName)">
            {{ scope.row.disCompanyName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="totalServiceFee"
        label="总服务费（元）"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.totalServiceFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="totalNumberTransactions"
        label="总笔数"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFeeRate"
        label="管理费率"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="totalManagementFee"
        label="总管理费（元）"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.totalManagementFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amountReceived"
        label="实际到账（元）"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.amountReceived.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTax"
        label="个税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.individualIncomeTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="valueAddedTax"
        label="增值税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.valueAddedTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="additionalTax"
        label="附加税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.additionalTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="完税模板"
        show-overflow-tooltip
        v-if="shouldShowButton()"
      >
        <template #default="scope">
          <el-link
            type="primary"
            @click="onOpenPayCertificateTemplate(scope.row)"
          >
            月度导出
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="summary-bar"
      v-if="listData && listData.length"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="summary-item">
            <span>总笔数：</span>
            <span>{{ currentPageSummary.totalNumberTransactions }}</span>
          </div>
          <div class="summary-item">
            <span>个税：</span>
            <span>{{
              formatNumber(currentPageSummary.individualIncomeTax)
            }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="summary-item">
            <span>总管理费：</span>
            <span>{{
              formatNumber(currentPageSummary.totalManagementFee)
            }}</span>
          </div>
          <div class="summary-item">
            <span>增值税：</span>
            <span>{{
              formatNumber(currentPageSummary.valueAddedTax)
            }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="summary-item">
            <span>总服务费：</span>
            <span>{{
              formatNumber(currentPageSummary.totalServiceFee)
            }}</span>
          </div>
          <div class="summary-item">
            <span>附加税：</span>
            <span>{{
              formatNumber(currentPageSummary.additionalTax)
            }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="summary-item">
            <span>实际到账：</span>
            <span>{{
              formatNumber(currentPageSummary.amountReceived)
            }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="500px"
      @click="closeDialog"
    >
      <el-form
        label-width="110px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="完税月份" prop="paymentMonth">
          <el-date-picker
            v-model="editForm.paymentMonth"
            type="month"
            placeholder="选择月份"
            value-format="yyyy-MM"
          >
            >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm()"
          >导出</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="batchTitle"
      :visible.sync="batchEditFormVisible"
      width="500px"
      @click="batchCloseDialog"
    >
      <el-form
        label-width="110px"
        :model="batchEditForm"
        :rules="rules"
        ref="batchEditForm"
      >
        <el-form-item label="完税月份" prop="paymentMonth">
          <el-date-picker
            v-model="batchEditForm.paymentMonth"
            type="month"
            placeholder="选择月份"
            value-format="yyyy-MM"
          >
            >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="batchCloseDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="batchSubmitForm()"
          >导出</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  merchantStatistics,
  exportmerchantstatistics,
  exportPaymentCertificateTmp,
  batchExportPaymentCertificateTmp,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      pickerOptions: {
        roleId: "",
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      batchEditFormVisible: false, //控制编辑页面显示与隐藏
      title: "导出完税模板",
      batchTitle: "批量导出完税模板",
      editForm: {
        merchantId: "",
        paymentMonth: "",
      },
      batchEditForm: {
        paymentMonth: "",
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
        batchNumber: "",
        date: [],
        disCompanyName: "",
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  computed: {
    currentPageSummary() {
      return this.listData.reduce(
        (acc, item) => {
          acc.totalNumberTransactions +=
            Number(item.totalNumberTransactions) || 0;
          acc.totalManagementFee += Number(item.totalManagementFee) || 0;
          acc.totalServiceFee += Number(item.totalServiceFee) || 0;
          acc.amountReceived += Number(item.amountReceived) || 0;
          acc.individualIncomeTax += Number(item.individualIncomeTax) || 0;
          acc.valueAddedTax += Number(item.valueAddedTax) || 0;
          acc.additionalTax += Number(item.additionalTax) || 0;
          return acc;
        },
        {
          totalNumberTransactions: 0,
          totalManagementFee: 0,
          totalServiceFee: 0,
          amountReceived: 0,
          individualIncomeTax: 0,
          valueAddedTax: 0,
          additionalTax: 0,
        }
      );
    },
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.roleId = JSON.parse(localStorage.getItem("user_info")).roleId;
    this.disCompanyId = JSON.parse(
      localStorage.getItem("user_info")
    ).distributeCompanyId;
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    onOpenBatchExport() {
      this.batchEditForm.paymentMonth = "";
      this.batchEditFormVisible = true;
    },

    onOpenExportLog() {
      this.$router.push({ path: "/payCenter/payCertExportLogs" });
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        merchantName: "",
        batchNumber: "",
        date: [],
        disCompanyName: "",
      };
      this.getdata();
    },
    //导出数据
    exportData() {
      let parameter = {
        page: 1,
        pageSize: 999999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        starTransactionDate:
          (this.formInline.date && this.formInline.date[0]) || "",
        endTransactionDate:
          (this.formInline.date && this.formInline.date[1]) || "",
      };

      exportmerchantstatistics(parameter).then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 获取公司列表
    getdata() {
      let parameter = {
        page: this.formInline.page,
        pageSize: this.formInline.pageSize,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        starTransactionDate:
          (this.formInline.date && this.formInline.date[0]) || "",
        endTransactionDate:
          (this.formInline.date && this.formInline.date[1]) || "",
      };
      merchantStatistics(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            this.listData.map((item) => {
              if (item.recruitmentStateDesc == "上线") {
                item.status = true;
              } else {
                item.status = false;
              }
            });
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          // this.$message.error('菜单加载失败，请稍后再试！')
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    onOpenPayCertificateTemplate(row) {
      this.editFormVisible = true;
      this.editForm.merchantId = row.merchantId;
      this.editForm.disCompanyId = row.disCompanyId;
      this.editForm.paymentMonth = "";
    },
    // 编辑、增加页面保存方法
    submitForm() {
      if (!this.editForm.merchantId) {
        this.$message.error("参数错误，商户id为空");
        return;
      }

      if (!this.editForm.disCompanyId) {
        this.$message.error("参数错误，服务商id为空");
        return;
      }

      if (!this.editForm.paymentMonth) {
        this.$message.error("参数错误，完税月份空");
        return;
      }

      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          exportPaymentCertificateTmp(
            this.editForm.merchantId,
            this.editForm.disCompanyId,
            this.editForm.paymentMonth
          )
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.msg == "success") {
                window.open(res.data.downloadUrl);
                this.$message({
                  type: "success",
                  message: "导出成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("导出完税证明失败，请稍后重试");
            });
        } else {
          return false;
        }
      });
    },
    batchSubmitForm() {
      if (!this.batchEditForm.paymentMonth) {
        this.$message.error("参数错误，完税月份为空");
        return;
      }

      if (!this.disCompanyId) {
        this.$message.error("服务商id为空");
        return;
      }

      let parameter = {
        page: 1,
        pageSize: 999999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        starTransactionDate:
          (this.formInline.date && this.formInline.date[0]) || "",
        endTransactionDate:
          (this.formInline.date && this.formInline.date[1]) || "",
      };

      batchExportPaymentCertificateTmp(
        this.disCompanyId,
        this.batchEditForm.paymentMonth,
        parameter
      ).then((res) => {
        if (res.msg == "success") {
          this.$message.success("正在导出中，请在导出记录中下载");
          this.$router.push({ path: "/payCenter/payCertExportLogs" });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
          if (res.code == 704) {
            this.$router.push({ path: "/payCenter/payCertExportLogs" });
          }
        }
      });
    },
    shouldShowButton() {
      if (this.roleId === 2) {
        return true;
      } else {
        return false;
      }
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
    batchCloseDialog() {
      this.batchEditFormVisible = false;
    },
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制到剪贴板",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制到剪贴板",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.summary-bar {
  background-color: #fff;
  padding: 15px;
  margin: 20px auto;
}
.summary-item {
  line-height: 1.8;
}
.summary-item + .summary-item {
  margin-top: 8px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/dataCenter/BusinessStatistics.vue